(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/tipsen/coupon/assets/javascripts/coupon-single-row-bet-buttons.js') >= 0) return;  svs.modules.push('/components/tipsen/coupon/assets/javascripts/coupon-single-row-bet-buttons.js');
"use strict";

const {
  useSelector,
  useDispatch
} = ReactRedux;
const {
  selectSystemType
} = svs.components.tipsen.engine.selectors.couponSelectors;
const {
  toggleAlternative
} = svs.components.tipsen.engine.actions;
const {
  useIsCurrentDrawPlayable
} = svs.components.tipsen.hooks;
const CouponSingleRowBetButtons = _ref => {
  let {
    couponId,
    outcomeLabels,
    radioRefs,
    boardIndex,
    numOfEvents,
    numOfBoards,
    eventIndex,
    selectedIndex,
    selections
  } = _ref;
  const dispatch = useDispatch();
  const isDrawPlayable = useIsCurrentDrawPlayable();
  const systemType = useSelector(state => selectSystemType(state, couponId));
  const handleSelect = outcomeIndex => {
    dispatch(toggleAlternative({
      boardIndex,
      couponId,
      event: eventIndex,
      outcome: outcomeIndex,
      systemType
    }));
  };
  const handleKeyDown = e => {
    if (e.key === 'ArrowDown') {
      e.preventDefault();
      if (eventIndex < numOfEvents - 1) {
        const selectedSign = selections[boardIndex][eventIndex + 1];
        const nextOutcomeIndex = selectedSign.findIndex(outcome => outcome);
        const fallbackIndex = 0;
        const focusIndex = nextOutcomeIndex !== -1 ? nextOutcomeIndex : fallbackIndex;
        if (radioRefs !== null && radioRefs !== void 0 && radioRefs.current) {
          var _radioRefs$current$bo;
          (_radioRefs$current$bo = radioRefs.current[boardIndex][eventIndex + 1][focusIndex]) === null || _radioRefs$current$bo === void 0 || _radioRefs$current$bo.focus();
        }
      } else if (boardIndex < numOfBoards - 1) {
        const selectedSign = selections[boardIndex + 1][0];
        const nextOutcomeIndex = selectedSign.findIndex(outcome => outcome);
        const fallbackIndex = 0;
        const focusIndex = nextOutcomeIndex !== -1 ? nextOutcomeIndex : fallbackIndex;
        if (radioRefs !== null && radioRefs !== void 0 && radioRefs.current) {
          var _radioRefs$current$0$;
          (_radioRefs$current$0$ = radioRefs.current[boardIndex + 1][0][focusIndex]) === null || _radioRefs$current$0$ === void 0 || _radioRefs$current$0$.focus();
        }
      }
    } else if (e.key === 'ArrowUp') {
      e.preventDefault();
      if (eventIndex > 0) {
        const selectedSign = selections[boardIndex][eventIndex - 1];
        const prevOutcomeIndex = selectedSign.findIndex(outcome => outcome);
        const fallbackIndex = 0;
        const focusIndex = prevOutcomeIndex !== -1 ? prevOutcomeIndex : fallbackIndex;
        if (radioRefs !== null && radioRefs !== void 0 && radioRefs.current) {
          var _radioRefs$current$bo2;
          (_radioRefs$current$bo2 = radioRefs.current[boardIndex][eventIndex - 1][focusIndex]) === null || _radioRefs$current$bo2 === void 0 || _radioRefs$current$bo2.focus();
        }
      } else if (boardIndex > 0) {
        const selectedSign = selections[boardIndex - 1][numOfEvents - 1];
        const prevOutcomeIndex = selectedSign.findIndex(outcome => outcome);
        const fallbackIndex = 0;
        const focusIndex = prevOutcomeIndex !== -1 ? prevOutcomeIndex : fallbackIndex;
        if (radioRefs !== null && radioRefs !== void 0 && radioRefs.current) {
          var _radioRefs$current$fo;
          (_radioRefs$current$fo = radioRefs.current[boardIndex - 1][numOfEvents - 1][focusIndex]) === null || _radioRefs$current$fo === void 0 || _radioRefs$current$fo.focus();
        }
      }
    }
  };
  return React.createElement("div", {
    className: "pg_coupon_srow_bet_btns"
  }, outcomeLabels.map((_ref2, outcomeIndex) => {
    let {
      sign,
      ariaLabel
    } = _ref2;
    return React.createElement("label", {
      className: "pg_coupon_srow_bet_btns__label qa-coupon-bet-button\n            ".concat(selectedIndex === outcomeIndex ? 'selected' : '', " \n            ").concat(isDrawPlayable ? '' : 'disabled'),
      "data-testid": "".concat(boardIndex, "_").concat(eventIndex, "_").concat(outcomeIndex),
      key: sign
    }, React.createElement("input", {
      "aria-describedby": "srow-".concat(boardIndex + 1, "-match-").concat(eventIndex + 1),
      "aria-label": ariaLabel,
      checked: selectedIndex === outcomeIndex,
      className: "pg_coupon_srow_bet_btns__label__input",
      disabled: !isDrawPlayable,
      name: "row".concat(boardIndex + 1, "-match").concat(eventIndex + 1),
      onChange: () => handleSelect(outcomeIndex),
      onKeyDown: handleKeyDown,
      ref: el => {
        var _radioRefs$current;
        if (radioRefs !== null && radioRefs !== void 0 && (_radioRefs$current = radioRefs.current) !== null && _radioRefs$current !== void 0 && (_radioRefs$current = _radioRefs$current[boardIndex]) !== null && _radioRefs$current !== void 0 && _radioRefs$current[eventIndex]) {
          radioRefs.current[boardIndex][eventIndex][outcomeIndex] = el;
        }
      },
      type: "radio",
      value: sign
    }), React.createElement("span", {
      "aria-hidden": "true"
    }, sign));
  }));
};
setGlobal('svs.components.tipsen.coupon.CouponSingleRowBetButtons', CouponSingleRowBetButtons);

 })(window);